import { render, staticRenderFns } from "./replyList.vue?vue&type=template&id=0d4a5f8e&scoped=true"
import script from "./replyList.vue?vue&type=script&lang=js"
export * from "./replyList.vue?vue&type=script&lang=js"
import style0 from "./replyList.vue?vue&type=style&index=0&id=0d4a5f8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d4a5f8e",
  null
  
)

export default component.exports